module.exports = __webpack_public_path__ + "static/SteelTank-03d7c17319d5f04fd20a274840e10776.svg";